import { render, staticRenderFns } from "./B-2-1-1c__NavigationEdit_Footer-Menu.vue?vue&type=template&id=e1de5554&"
import script from "./B-2-1-1c__NavigationEdit_Footer-Menu.vue?vue&type=script&lang=js&"
export * from "./B-2-1-1c__NavigationEdit_Footer-Menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports